var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHtm = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#005871",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.76 17.61h1.21v2.89h3.21v-2.89h1.21v7.14h-1.21v-3.13H6.97v3.13H5.76zm8.838 1.05h-2.26v-1.05h5.72v1.05h-2.25v6.09h-1.21zm4.414-1.05h1.47l2.03 5.68 2.09-5.68h1.42v7.14h-1.11v-5.19l-1.96 5.19h-.96l-1.89-5.18v5.18h-1.09z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHtm);
export default ForwardRef;